import type { FC } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import type { SportsEventSearchResult } from "src/http/api-types";
import { useCarouselPaging } from "src/shared/hooks/useCarouselPaging";
import { CarouselWithArrows } from "src/website-apps/shared/components/carousel";
import { StyledEventsNearYouCarousel, StyledMatchupCard } from "./styled-components";

interface Props {
  events: SportsEventSearchResult[];
  id: string;
  onClick: (id: number | undefined) => void;
}

/**
 * Teams Near You Carousel UI (Desktop & Tablet)
 */
export const EventsNearYouCarousel: FC<Props> = ({ events, id, onClick }) => {
  const isDesktop = useMediaQuery(Breakpoint.Desktop);
  const isTabletUp = useMediaQuery(Breakpoint.Tablet);
  const isTablet = isTabletUp && !isDesktop;
  const { onNextArrowClick, onPrevArrowClick, page, remaining } = useCarouselPaging({
    data: events,
    id,
    pageSize: 3,
  });

  return (
    <StyledEventsNearYouCarousel>
      <CarouselWithArrows
        fluidHeight
        id={id}
        items={events}
        onNext={onNextArrowClick}
        onPrev={onPrevArrowClick}
        page={page}
        pageSize={isTablet ? 2 : 3}
        remain={remaining}
        renderItem={(evt: SportsEventSearchResult) => (
          <StyledMatchupCard key={evt.eventId} onClick={onClick} {...evt} />
        )}
      />
    </StyledEventsNearYouCarousel>
  );
};
